import { toast } from "react-toastify";

/**
 * Reusable toast function
 * @param {string} title - Title of the toast
 * @param {string} message - Message body
 * @param {string} type - 'success' | 'error' | 'info' | 'warn'
 * @param {number} [autoClose=3000] - Duration in milliseconds (optional, default: 3s)
 */
export const showToast = (title, message, type = "info", autoClose = 3000) => {
  toast[type](
    <div>
      <strong style={{ fontSize: "14px" }}>{title}</strong>
      <div style={{ fontSize: "13px", marginTop: "4px" }}>{message}</div>
    </div>,
    {
      autoClose,
      position: "top-right",
    }
  );
};
